/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiProductTaggerUniqueFieldFromJSON, ApiProductTaggerUniqueFieldToJSON, } from './ApiProductTaggerUniqueField';
export function ApiProductTaggerPayloadFromJSON(json) {
    return ApiProductTaggerPayloadFromJSONTyped(json, false);
}
export function ApiProductTaggerPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brandSelector': !exists(json, 'brandSelector') ? undefined : json['brandSelector'],
        'categorySelector': !exists(json, 'categorySelector') ? undefined : json['categorySelector'],
        'descriptionSelector': !exists(json, 'descriptionSelector') ? undefined : json['descriptionSelector'],
        'imageUrlSelector': !exists(json, 'imageUrlSelector') ? undefined : json['imageUrlSelector'],
        'priceSelector': !exists(json, 'priceSelector') ? undefined : json['priceSelector'],
        'productIdSelector': !exists(json, 'productIdSelector') ? undefined : json['productIdSelector'],
        'productSkuSelector': !exists(json, 'productSkuSelector') ? undefined : json['productSkuSelector'],
        'titleSelector': !exists(json, 'titleSelector') ? undefined : json['titleSelector'],
        'uniqueField': !exists(json, 'uniqueField') ? undefined : ApiProductTaggerUniqueFieldFromJSON(json['uniqueField']),
        'useLinkedData': !exists(json, 'useLinkedData') ? undefined : json['useLinkedData'],
    };
}
export function ApiProductTaggerPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brandSelector': value.brandSelector,
        'categorySelector': value.categorySelector,
        'descriptionSelector': value.descriptionSelector,
        'imageUrlSelector': value.imageUrlSelector,
        'priceSelector': value.priceSelector,
        'productIdSelector': value.productIdSelector,
        'productSkuSelector': value.productSkuSelector,
        'titleSelector': value.titleSelector,
        'uniqueField': ApiProductTaggerUniqueFieldToJSON(value.uniqueField),
        'useLinkedData': value.useLinkedData,
    };
}
